export const REDUCER_KEY = 'order';

export const PUBLISHER_GENERATE_ORDER_REQUESTED =
  'PUBLISHER_GENERATE_ORDER_REQUESTED';
export const BUYER_SIGNATURE_REQUESTED = 'BUYER_SIGNATURE_REQUESTED';
export const PUBLISHER_CORRECTION_REQUESTED = 'PUBLISHER_CORRECTION_REQUESTED';
export const BUYER_CORRECTION_REQUESTED = 'BUYER_CORRECTION_REQUESTED';

export const FINALIZED = 'FINALIZED';
export const TERMINATED = 'TERMINATED';

export type StatusExplanation = {
  key: string;
  fallback: string;
};

export const NEGOTIATIONS = [
  PUBLISHER_GENERATE_ORDER_REQUESTED,
  BUYER_SIGNATURE_REQUESTED,
  PUBLISHER_CORRECTION_REQUESTED,
  BUYER_CORRECTION_REQUESTED,
  FINALIZED,
];

export const STATUSES_EXPLANATION: Record<string, StatusExplanation[]> = {
  [PUBLISHER_GENERATE_ORDER_REQUESTED]: [
    {
      key: 'order.userGeneratedRequest',
      fallback: 'Prośba wygenerowana przez użytkownika',
    },
  ],
  [BUYER_SIGNATURE_REQUESTED]: [
    {
      key: 'order.userSubmittedDocument',
      fallback: 'Dokument przesłany przez użytkownika',
    },
  ],
  [PUBLISHER_CORRECTION_REQUESTED]: [
    {
      key: 'order.userSubmittedComments',
      fallback: 'Uwagi przesłane przez użytkownika',
    },
  ],
  [BUYER_CORRECTION_REQUESTED]: [
    {
      key: 'order.userSubmittedComments',
      fallback: 'Uwagi przesłane przez użytkownika',
    },
  ],
};
